import React, { useEffect, useState, useRef } from "react";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from "reactstrap";
import { Notification, FullViewContainer, Icon } from "../common/style";
import { AccordionHeaderContainer } from "./style";
import CrudModal from "./CrudModal";
import { deleteItems } from "../product/service";
import {
  updateUserGroup,
  sortSectionItems,
  updateSection,
  updateOrderItemProperties,
  copyPasteOrderItem,
  copyPasteSection,
  loadGroup,
  loadModule,
  sortDirectItems,
} from "./service";
import {
  removeProjectOverride,
  copyItemsV2,
  updateOrderItemData,
} from "../product/service";
import ConfirmationModal from "./ConfirmationModal";
import Cell from "./table/Cell";
import NameCell from "./table/cells/NameCell";
import ColorCell from "./table/cells/ColorCell";
import DimensionCell from "./table/cells/DimensionCell";
import FillerCell from "./table/cells/FillerCell";
import PriceCell from "./table/cells/PriceCell";
import PropertyCell from "./table/cells/PropertyCell";
import AddModuleDialog from "./table/AddModuleDialog";
import AddSectionModal from "./table/AddSectionModal";
import RightPanel from "./table/RightPanel";
import AddDirectModuleDialog from "./table/AddDirectModuleDialog";
import SectionTableHeader from "./table/SectionTableHeader";
import { isMobileOnly } from "react-device-detect";
import MobileBanner from "../common/MobileBanner";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import {
  restrictToVerticalAxis,
  restrictToParentElement,
} from "@dnd-kit/modifiers";
import { CSS } from "@dnd-kit/utilities";
import ContextMenu from "./table/ContextMenu";
const SectionAccordion = ({
  isLoading,
  setIsLoading,
  currentRoom,
  projectSummary,
  selectionManager,
  projectId,
  loadRoom,
  access,
  refreshProjectSummary,
  mutateCurrentRoom,
  isAdmin,
  finalisedContexts,
  isorderfinalised,
  currentSelection,
  setCurrentTab,
  setRoom,
  showSpec,
  isListProject,
}) => {
  const selectionManagerRef = useRef(selectionManager);
  const [notification, setNotification] = useState({ type: "", message: "" });
  const [isNotificationVisible, setIsNotificationVisible] = useState(true);
  const [currentGroup, setCurrentGroup] = useState(null);
  const [addedProductLoading, setAddedProductLoading] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState({});
  const [disableAddModuleCell, setDisableAddModuleCell] = useState(false);
  const [addedProductsWidth, setAddedProductsWidth] = useState(0);
  const [editGroup, setEditGroup] = useState(false);
  const [activeSectionId, setActiveSectionId] = useState(null);
  const [showAddSection, setShowAddSection] = useState(false);
  const [showAddDirectModules, setShowAddDirectModules] = useState(false);
  const [isRightPanelVisible, setIsRightPanelVisible] = useState(false);
  const [sectionDimensions, setSectionDimensions] = useState({
    height: {},
    width: {},
    depth: {},
  });
  const [moduleDimensions, setModuleDimensions] = useState({
    height: {},
    width: {},
    depth: {},
  });
  const [currentCell, setCurrentCell] = useState({
    id: null,
    type: null,
    column: null,
    status: null,
    errorMessage: null,
  });
  const [copyPasteTooltip, setCopyPasteTooltip] = useState({
    show: false,
    message: "",
    target: null,
  });
  const [copiedCell, setCopiedCell] = useState({
    id: null,
    type: null,
    column: null,
  });
  const [highlightedCell, setHighlightedCell] = useState({
    id: null,
    type: null,
    column: null,
  });
  const [openClearOverrideModal, setOpenClearOverrideModal] = useState(false);
  const [clearOverrideFunc, setClearOverrideFunc] = useState(false);
  const [orderItemNames, setOrderItemNames] = useState({});
  const [sectionNames, setSectionNames] = useState({});
  const [orderItemUserLabel, setOrderItemUserLabel] = useState();
  const [blurredItems, setBlurredItems] = useState({});
  const [editingCell, setEditingCell] = useState(null);
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 10,
      },
    })
  );
  const [blurLabel, setBlurLabel] = useState("");
  const [blurDirectModuleLabel, setBlurDirectModuleLabel] = useState([]);
  const [copiedDate, setCopiedData] = useState("");
  const [pasteOverrides, setPasteOverrides] = useState({});
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    target: null, // 'cell' or 'row'
    item: null, // The item being right-clicked
    cellData: null, // Only for cell context
    forDirectModules: false, //copy for paste as direct module
  });
  const [showItemsDeleteConfirmation, setShowItemsDeleteConfirmation] =
    useState(false);
  const toggleShowItemsDeleteConfirmation = () =>
    setShowItemsDeleteConfirmation(!showItemsDeleteConfirmation);

  // FIXME
  const colorIdentifiers = ["shutter_color", "internal_color"];
  const moduleColorIdentifiers = ["color", "internal_color"];

  const toggleEditGroup = () => setEditGroup(!editGroup);

  const toggleClearOverrideModal = () =>
    setOpenClearOverrideModal(!openClearOverrideModal);

  const toggleAddSectionModal = () => setShowAddSection(!showAddSection);

  const onDismissNotification = () => {
    setIsNotificationVisible(false);
  };

  const showCopyPasteTooltip = (message, target) => {
    setCopyPasteTooltip({ show: true, message, target });
    setTimeout(() => {
      setCopyPasteTooltip({ show: false, message: "", target: null });
    }, 5000);
  };
  const canPaste = (targetType, item) => {
    try {
      if (targetType === "cell") {
        const cellClipboard = localStorage.getItem("copiedCellData");

        const pastingData =
          item.type == "group"
            ? tableManager.isCurrentlyFocused()
            : currentCell;
        if (!cellClipboard) return false;

        const { copy_data } = JSON.parse(cellClipboard);
        if (!copy_data || !pastingData) return false;

        return (
          copy_data.type === pastingData.type &&
          copy_data.column === pastingData?.column
        );
      } else {
        const rowClipboard = localStorage.getItem("copiedObjects");

        if (!rowClipboard) return false;

        const copy_data = JSON.parse(rowClipboard);
        if (!copy_data) return false;

        const hasModuleData = copy_data?.items?.[0]?.type === "module";
        const isTargetGroup = currentSelection?.[0]?.type === "group";

        return hasModuleData && isTargetGroup;
      }
    } catch {
      return false;
    }
  };
  const deleteSelectedItems = (items) => {
    selectionManager.removeItems(items);

    if (isListProject && items[0].type === "module" && items[0].is_packed)
      selectionManager.select(selectionManager.findGroup(items[0].group_id));

    deleteItems({
      projectId: projectId,
      roomId: currentRoom.id,
      items: items.map(({ type, id }) => ({
        type,
        id,
      })),
    })
      .then((room) => {
        setRoom(room);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          text: error,
          type: "danger",
        });
      });
  };
  const handleContextMenu = (
    e,
    target,
    item,
    itemOrCellInfo,
    forDirectModules = false
  ) => {
    e.preventDefault();
    e.stopPropagation();
    if (target == "row" && !forDirectModules) {
      selectionManager.select(item);
    }
    if (itemOrCellInfo) {
      tableManager.set(
        itemOrCellInfo.id,
        itemOrCellInfo.type,
        itemOrCellInfo.column,
        "focus"
      );
    }
    setContextMenu({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      target,
      item,
      cellData: itemOrCellInfo ? itemOrCellInfo : null,
      forDirectModules: forDirectModules,
    });
  };

  const handleCloseContextMenu = () => {
    setContextMenu((prev) => ({ ...prev, visible: false }));
  };

  const handleContextMenuCopy = () => {
    if (contextMenu.target === "cell") {
      handleCopyCell();
    } else {
      handleCopy();
    }
    setContextMenu({ ...contextMenu, visible: false });
  };

  const handleContextMenuPaste = (forDirectModules = false) => {
    if (contextMenu.target === "cell") {
      handlePasteCell();
    } else if (forDirectModules) {
      handlePaste(forDirectModules);
    } else {
      handlePaste();
    }
    setContextMenu({ ...contextMenu, visible: false });
  };

  useEffect(() => {
    selectionManagerRef.current = selectionManager;

    // On load, open the active section accordion.
    if (selectionManager.activeGroupId()) {
      setActiveSectionId(selectionManager.activeGroupId());
    }
  }, [selectionManager]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentCell]);

  useEffect(() => {
    const hasOtherSelection = selectionManager
      .selections()
      .some((s) => s.type !== "module" && s.type !== "group");

    if (hasOtherSelection) {
      setIsRightPanelVisible(true);
    } else {
      setIsRightPanelVisible(false);
    }
  }, [selectionManager.selections()]);

  useEffect(() => {
    const handleGlobalClick = () => {
      if (contextMenu.visible) {
        handleCloseContextMenu();
      }
    };

    window.addEventListener("click", handleGlobalClick);
    return () => {
      window.removeEventListener("click", handleGlobalClick);
    };
  }, [contextMenu.visible]);

  const canBlur = (groupId, dimension) => {
    return blurredItems[groupId] === dimension;
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (tableManager.isCurrentlyFocused()) {
        tableManager.set(
          currentCell.id,
          currentCell.type,
          currentCell.column,
          "active"
        );
      }
    }
    if (event.key === "Tab") {
      event.preventDefault();
      handleTabNavigation();
      return;
    }
    if (event.key === "Escape") {
      setShowAddDirectModules(false);
      setSectionNames({});
      setOrderItemNames({});
      setCurrentTab("info");
      setAddedProductsWidth(0);
      if (tableManager.isCurrentlyActive()) {
        tableManager.setStatus("focus");
      } else {
        if (tableManager.isCurrentlyFocused()) {
          tableManager.clear();
        }
      }
    }
    if (event.key === "c" && (event.ctrlKey || event.metaKey)) {
      if (tableManager.isCurrentlyFocused()) {
        handleCopyCell();
      } else {
        handleCopy();
      }
    }

    if (
      event.key === "v" &&
      (event.ctrlKey || event.metaKey) &&
      access.customize_module
    ) {
      if (tableManager.isCurrentlyFocused()) {
        handlePasteCell();
      } else {
        handlePaste();
      }
    }
  };

  const handleDuplicate = () => {
    handleCopy();
    handlePaste();
  };

  const handleCopy = (isCut = false) => {
    const selections = selectionManagerRef.current.selections();
    if (
      selections.length > 0 &&
      selections.every((selection) =>
        ["section", "module", "group"].includes(selection.type)
      )
    ) {
      localStorage.setItem(
        "copiedObjects",
        JSON.stringify({
          operation: isCut ? "cut" : "copy",
          items: selections.map(({ type, id }) => ({ type, id })),
        })
      );
    }
  };

  const handlePaste = (forDirectModules = false) => {
    const text = localStorage.getItem("copiedObjects");
    let clipboardSelections;
    try {
      clipboardSelections = JSON.parse(text);
    } catch (error) {
      return;
    }

    if (
      clipboardSelections &&
      clipboardSelections.items &&
      clipboardSelections.items.length > 0 &&
      ["cut", "copy"].includes(clipboardSelections.operation)
    ) {
      // TODO: Cut+Paste behaves like Copy+Paste for now.
      // setCanvasLoading(true);

      // COPY ITEMS
      setIsLoading(true);
      copyItemsV2({
        projectId: projectId,
        roomId: selectionManagerRef.current.currentRoom().id,
        items: clipboardSelections.items,
        target:
          selectionManagerRef.current.activeGroup() && !forDirectModules
            ? {
                type: selectionManagerRef.current.activeGroup().type,
                id: selectionManagerRef.current.activeGroup().id,
              }
            : null,
      })
        .then((response) => {
          selectionManager.triggerLoadRoom(
            selectionManagerRef.current.currentRoom().id,
            null,
            response.copied_objects,
            true
          );
          refreshProjectSummary();
          selectionManager.select(response.copied_objects[0]);
        })
        .catch(({ error }) => {
          setIsNotificationVisible(true);
          setNotificationMessage({
            text: "Error Pasting items: " + error?.error,
            type: "danger",
          });
        })
        .finally(() => {
          // setCanvasLoading(false);
          setIsLoading(false);
          setTimeout(() => {
            localStorage.removeItem("copiedObjects");
            localStorage.removeItem("copiedCellData");
          }, 500);
        });
    }
  };
  const handleTabNavigation = () => {
    if (!currentCell) return;

    const { id, type, column } = currentCell;
    const columnOrder = [
      "name",
      "height",
      "width",
      "depth",
      "color",
      "filler",
      "property",
      "price",
    ];
    const currentIndex = columnOrder.indexOf(column);

    if (currentIndex === -1) return;

    if (currentIndex < columnOrder.length - 1) {
      const nextColumn = columnOrder[currentIndex + 1];
      tableManager.set(id, type, nextColumn, "focus");
      return;
    }

    if (type === "section") {
      const group = selectionManager.findGroup(id);
      if (group.modules.length > 0) {
        tableManager.set(group.modules[0].id, "module", "name", "focus");
      } else {
        moveToNextSectionOrDirectModule(id);
      }
    } else {
      const module = selectionManager.findModule(id);
      if (module.group_id) {
        const group = selectionManager.findGroup(module.group_id);
        const moduleIndex = group.modules.findIndex((m) => m.id === id);

        if (moduleIndex < group.modules.length - 1) {
          tableManager.set(
            group.modules[moduleIndex + 1].id,
            "module",
            "name",
            "focus"
          );
        } else {
          moveToNextSectionOrDirectModule(group.id);
        }
      } else {
        const moduleIndex = currentRoom.modules.findIndex((m) => m.id === id);
        if (moduleIndex < currentRoom.modules.length - 1) {
          tableManager.set(
            currentRoom.modules[moduleIndex + 1].id,
            "module",
            "name",
            "focus"
          );
        } else {
          if (currentRoom.groups.length > 0) {
            tableManager.set(
              currentRoom.groups[0].id,
              "section",
              "name",
              "focus"
            );
          }
        }
      }
    }
  };

  const moveToNextSectionOrDirectModule = (currentGroupId) => {
    const groupIndex = currentRoom.groups.findIndex(
      (g) => g.id === currentGroupId
    );

    if (groupIndex < currentRoom.groups.length - 1) {
      const nextGroup = currentRoom.groups[groupIndex + 1];
      tableManager.set(nextGroup.id, "section", "name", "focus");
    } else if (currentRoom.modules.length > 0) {
      tableManager.set(currentRoom.modules[0].id, "module", "name", "focus");
    } else if (currentRoom.groups.length > 0) {
      tableManager.set(currentRoom.groups[0].id, "section", "name", "focus");
    }
  };
  const handleCopyCell = (isCut = false) => {
    if (!currentCell) return;
    localStorage.setItem(
      "copiedCellData",
      JSON.stringify({
        operation: isCut ? "cut" : "copy",
        copy_data: currentCell,
      })
    );
    tableManager.setCopiedCell(
      currentCell.id,
      currentCell.type,
      currentCell.column
    );
    setTimeout(() => {
      tableManager.clearCopiedCell();
    }, 1000);
  };

  const handlePasteCell = () => {
    const text = localStorage.getItem("copiedCellData");
    let clipboardCellData;
    try {
      clipboardCellData = JSON.parse(text);
    } catch (error) {
      console.error("Invalid clipboard data");
      return;
    }

    if (
      clipboardCellData &&
      clipboardCellData.copy_data &&
      ["cut", "copy"].includes(clipboardCellData.operation)
    ) {
      const { id, column, type } = currentCell;
      const sourceCell = clipboardCellData.copy_data;
      const targetCell = currentCell;

      if (sourceCell.type !== targetCell.type) {
        showCopyPasteTooltip(
          `Can only paste ${sourceCell.type} data to ${sourceCell.type}`,
          `cell_${targetCell.type}_${targetCell.id}_${targetCell.column}`
        );
        return;
      }
      if (sourceCell.column !== targetCell.column) {
        showCopyPasteTooltip(
          `Can only paste ${sourceCell.column} data to ${sourceCell.column}`,
          `cell_${targetCell.type}_${targetCell.id}_${targetCell.column}`
        );
        return;
      }
      const copiedItem =
        sourceCell.type === "module"
          ? selectionManager.findModule(sourceCell.id)
          : selectionManager.findGroup(sourceCell.id);

      if (copiedItem) {
        let pasteValue;
        if (["height", "width", "depth"].includes(sourceCell.column)) {
          pasteValue = copiedItem.dimensions[sourceCell.column];
        } else if (sourceCell.column === "name") {
          pasteValue = copiedItem.name;
        } else if (sourceCell.column === "color") {
          pasteValue = {
            shutter_color: copiedItem.selected_values?.shutter_color,
            color: copiedItem.selected_values?.color,
            internal_color: copiedItem.selected_values?.internal_color,
          };
        } else if (sourceCell.column === "property") {
          pasteValue = { selected_values: copiedItem.selected_values };
        } else if (
          sourceCell.column === "filler" &&
          sourceCell.type == "section"
        ) {
          pasteValue = { sides: copiedItem.sides };
        } else if (
          (sourceCell.column === "filler") &
          (sourceCell.type == "module")
        ) {
          pasteValue = {
            exposed_side_left: copiedItem.selected_values?.exposed_side_left,
            exposed_side_right: copiedItem.selected_values?.exposed_side_right,
            exposed_side_top: copiedItem.selected_values?.exposed_side_top,
            exposed_side_bottom:
              copiedItem.selected_values?.exposed_side_bottom,
            exposed_side_back: copiedItem.selected_values?.exposed_side_back,
            left_expo_color: copiedItem.selected_values?.left_expo_color,
            right_expo_color: copiedItem.selected_values?.right_expo_color,
            top_expo_color: copiedItem.selected_values?.top_expo_color,
            bottom_expo_color: copiedItem.selected_values?.bottom_expo_color,
            back_expo_color: copiedItem.selected_values?.back_expo_color,
          };
        } else {
          console.error("Unsupported column type for paste");
          return;
        }
        setPasteOverrides((prev) => ({
          ...prev,
          [`${id}-${type}-${column}`]: pasteValue,
        }));
      }
      if (sourceCell && targetCell) {
        const payload = {
          copy_id: sourceCell.id,
          column: sourceCell.column,
        };
        if (currentCell.type == "module") {
          tableManager.highlight(currentCell.id, "module", currentCell.column);

          copyPasteOrderItem({
            projectId,
            orderItemId: currentCell.id,
            ...payload,
          })
            .then((module) => {
              replaceModule(module);
              setBlurredItems((prev) => {
                const updated = { ...prev };
                delete updated[module.id];
                return updated;
              });
              setNotification({
                type: "success",
                message: "Copied successfully!",
              });
              setIsNotificationVisible(true);
            })
            .catch((error) => {
              setIsNotificationVisible(true);
              setNotificationMessage({
                text: "Error Pasting cell: " + error?.error,
                type: "danger",
              });
            })
            .finally(() => {
              tableManager.highlight(
                currentCell.id,
                "module",
                currentCell.column
              );

              setTimeout(() => {
                localStorage.removeItem("copiedObjects");
                localStorage.removeItem("copiedCellData");
              }, 500);
            });
        }
        if (currentCell.type == "section") {
          tableManager.highlight(currentCell.id, "section", currentCell.column);

          copyPasteSection({
            id: currentCell.id,
            ...payload,
          })
            .then((section) => {
              replaceGroup(section);
              setBlurredItems((prev) => {
                const updated = { ...prev };
                delete updated[section.id];
                return updated;
              });
            })
            .catch((error) => {
              setIsNotificationVisible(true);
              setNotificationMessage({
                text: "Error Pasting Cell: " + error?.error,
                type: "danger",
              });
            })
            .finally((_) =>
              tableManager.highlight(
                currentCell.id,
                "section",
                currentCell.column
              )
            );
        }
      }
      setTimeout(() => {
        setHighlightedCell(null);
      }, 2000);
    }
  };

  const updateGroup = ({ projectId, groupId, roomId, payload }) => {
    setIsLoading(true);

    return updateUserGroup({ projectId, groupId, payload })
      .then((_) => {
        updateLocalProject({
          entity: "group",
          entityId: groupId,
          entityName: payload.name,
          parentId: roomId,
          action: "update",
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      })
      .finally((_) => setIsLoading(false));
  };

  const handleUpdateSectionName = (groupId) => {
    const name = sectionNames[groupId];

    if (!name || name.trim().length === 0) return;

    selectionManager.findGroup(groupId).name = name;

    return updateSection({
      id: groupId,
      name: name,
    }).catch(({ error }) => {
      setIsNotificationVisible(true);
      setNotification({ type: "error", message: error });
    });
  };

  const updateLocalProject = ({
    entity = "room",
    entityId,
    entityName,
    parentId = null, // roomId for entity 'Group'
    action,
  }) => {
    if (entity === "group") {
      return updateLocalGroup({
        groupId: entityId,
        groupName: entityName,
        roomId: parentId,
        action,
      });
    }
  };

  const updateLocalGroup = ({ roomId, groupName, groupId, action }) => {
    // Mutating "project" -> To update the group names in module "Add To Room" CTA
    switch (action) {
      case "add": {
        currentRoom.groups.push({
          id: groupId,
          name: groupName,
          modules: [],
          position: { x: 0, y: 0 },
          dimensions: { height: 0, width: 0, depth: 0 },
          type: "group",
          category: "StackedGroup",
        });

        break;
      }
      case "update": {
        const groupIndex = currentRoom.groups.findIndex(
          (group) => group.id == groupId
        );

        currentRoom.groups[groupIndex].name = groupName;
        currentRoom.groups[groupIndex] = {
          ...currentRoom.groups[groupIndex],
          name: groupName,
        };

        break;
      }
      case "delete": {
        currentRoom.groups = currentRoom.groups.filter(
          (group) => group.id !== groupId
        );

        loadRoom(currentRoom.id);

        break;
      }
    }
  };

  const handleDimensionChange = (dimension, id, value, item) => {
    const setterFunc =
      item === "section" ? setSectionDimensions : setModuleDimensions;

    setterFunc((prev) => ({
      ...prev,
      [dimension]: {
        ...prev[dimension],
        [id]: value,
      },
    }));
  };

  const isDimensionNotValid = (dimension, value) => {
    if (value == null) return;

    if (parseInt(value) > 2400 && dimension !== "width") {
      return true;
    }

    return value.length > 0 && !/^\d*$/.test(value);
  };

  const isNameNotValid = (value) => value === "";

  const replaceGroup = (updatedGroup) => {
    const group =
      selectionManager.findGroup(updatedGroup.id) ||
      selectionManager.findGroupByTempId(updatedGroup.temp_id);

    delete updatedGroup.temp_id;
    delete group.temp_id;
    Object.assign(group, updatedGroup);
  };

  const replaceGroupForModuleChange = (
    updatedGroup,
    childId,
    dimensionKey,
    shouldUpdateFromServer
  ) => {
    const group = selectionManager.findGroup(updatedGroup.id);

    const newGroup = {
      ...updatedGroup,
      modules: updatedGroup.modules.map((m) => {
        if (m.id == childId) {
          replaceServerDataForModule(
            m,
            shouldUpdateFromServer ? dimensionKey : ""
          );

          return group.modules.find((module) => module.id == m.id);
        } else return m;
      }),
    };

    Object.assign(group, newGroup);
  };

  const replaceModule = (updatedModule) => {
    const module =
      selectionManager.findModule(updatedModule.id) ||
      selectionManager.findModuleByTempId(updatedModule.temp_id);

    delete updatedModule.temp_id;
    delete module.temp_id;
    Object.assign(module, updatedModule);
  };

  const replaceServerDataForModule = (updatedModule, dimensionKey) => {
    const module = selectionManager.findModule(updatedModule.id);

    replaceModule({
      ...module,
      template: updatedModule.template,
      price: updatedModule.price,
      price_per_sqft: updatedModule.price_per_sqft,
      price_meta: updatedModule.price_meta,
      original_price: updatedModule.original_price,
      property_list: updatedModule.property_list,
      selected_values: updatedModule.selected_values,
      has_profile_shutter: updatedModule.has_profile_shutter,
      handle: updatedModule.handle,
      show_depth: updatedModule.show_depth,
      position: updatedModule.position,
      dimensions_overriden: updatedModule.dimensions_overriden,
      ...(dimensionKey && {
        dimensions: {
          ...module.dimensions,
          [dimensionKey]: updatedModule.dimensions[dimensionKey],
        },
      }),
    });
  };

  const updateSectionDimensions = ({ group, dimension, value }) => {
    if (
      typeof value != "string" ||
      value.trim().length === 0 ||
      isDimensionNotValid(dimension, value)
    ) {
      return;
    }

    if (dimension !== "width") {
      // For height and depth, copy the value to non-overriden modules.
      group.modules.forEach((module) => {
        if (!module.dimensions_overriden[dimension]) {
          module.dimensions[dimension] = parseInt(value);
        }
      });
    }

    setBlurredItems((prev) => ({
      ...prev,
      [group.id]: dimension,
    }));

    return updateSection({
      id: group.id,
      dimension: { [dimension]: value },
    })
      .then((section) => {
        replaceGroup(section);
        handleDimensionChange(dimension, group.id, null, "section");
        refreshProjectSummary();
        tableManager.clearError("section", group.id, dimension);
        tableManager.clearEditingCell();

        setBlurredItems((prev) => {
          const updated = { ...prev };
          delete updated[group.id];
          return updated;
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
        tableManager.setErrorMessage(error, group.id, "section", dimension);
      });
  };

  const updateSectionProperties = ({
    id,
    propIdentifier,
    optionIdentifier,
  }) => {
    return updateSection({
      id,
      property: { [propIdentifier]: optionIdentifier },
    })
      .then((section) => {
        replaceGroup(section);
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
        tableManager.setErrorMessage(error, id, "section", "property");
      });
  };

  const updateSectionFillers = ({ id, sides }) => {
    setBlurredItems((prev) => ({
      ...prev,
      [id]: "width",
    }));
    return updateSection({ id, sides })
      .then((section) => {
        section.position = selectionManager.calculateGroupPosition(
          section.modules
        );
        replaceGroup(section);
        refreshProjectSummary();
        setBlurredItems((prev) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
        tableManager.setErrorMessage(error, id, "section", "filler");
      });
  };

  const updateModuleDimensions = ({ orderItem, dimension }) => {
    let val = dimension?.value;
    if (
      typeof val !== "string" ||
      isDimensionNotValid(dimension.identifier, val)
    ) {
      return;
    }

    val = parseInt(val);

    setBlurredItems((prev) => ({
      ...prev,
      [orderItem.group_id]: dimension.identifier,
    }));

    let shouldUpdateFromServer = false;

    if (val) {
      orderItem.dimensions[dimension.identifier] = val;
      orderItem.dimensions_overriden[dimension.identifier] = true;
    } else {
      if (!orderItem.dimensions_overriden[dimension.identifier]) return;

      shouldUpdateFromServer = true;
    }

    return updateOrderItemProperties({
      projectId,
      orderItemIds: [orderItem.id],
      dimensions: { [dimension.identifier]: val },
    })
      .then((response) => {
        if (Array.isArray(response))
          response.forEach((item) => replaceServerDataForModule(item));
        else
          replaceGroupForModuleChange(
            response,
            orderItem.id,
            dimension.identifier,
            shouldUpdateFromServer
          );
        tableManager.clearEditingCell();
        clearModuleDimensionsForModule(orderItem.id);
        refreshProjectSummary();
        tableManager.clearError("module", orderItem.id, dimension.identifier);
        setBlurredItems((prev) => {
          const updated = { ...prev };
          delete updated[orderItem.group_id];
          return updated;
        });
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
        tableManager.setErrorMessage(
          error,
          orderItem.id,
          "module",
          dimension.identifier
        );
      });
  };

  const updateModuleProperties = ({ id, propIdentifier, optionIdentifier }) => {
    return updateOrderItemProperties({
      projectId,
      orderItemIds: [id],
      properties: { [propIdentifier]: optionIdentifier },
    })
      .then((response) => {
        if (Array.isArray(response))
          response.forEach((item) => replaceServerDataForModule(item));
        else replaceGroup(response);

        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
        tableManager.setErrorMessage(error, id, "module", "property");
      });
  };

  const clearModuleOverrides = ({ id, propIdentifier }) => {
    removeProjectOverride({
      projectId,
      orderItemIds: [id],
      propertyIdentifier: propIdentifier,
    })
      .then((orderItems) => {
        orderItems.forEach((o) => replaceServerDataForModule(o));
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotification({ type: "error", message: error });
      });
  };
  const clearPasteOverride = (id, type, column) => {
    setPasteOverrides((prev) => {
      const copy = { ...prev };
      delete copy[`${id}-${type}-${column}`];
      return copy;
    });
  };

  const handleUpdateOrderItemData = (orderItemId) => {
    const orderItemName = orderItemNames[orderItemId];

    if (!orderItemName || orderItemName.trim().length === 0) return;

    selectionManager.findModule(orderItemId).name = orderItemName;

    updateOrderItemData({
      projectId,
      groupId: selectionManager.activeGroupId(),
      orderItemId,
      orderItemName,
      orderItemUserLabel,
    }).catch(({ error }) => {
      setIsNotificationVisible(true);
      setNotification({ type: "error", message: error });
    });
  };

  const LineItem = (orderItem, dragHandleProps = {}) => {
    const moduleErrorFields = orderItem.module_errors
      ? Object.keys(orderItem.module_errors)
      : [];
    const selectedGroup = selectionManager.findGroup(orderItem.group_id);

    const isGroupSelected =
      orderItem.group_id && selectionManager.isSelected(selectedGroup);

    const isLineItemSelected = selectionManager.isSelected(orderItem);

    const isSiblingOfSelectedLineItem =
      selectionManager.selectedModule() && orderItem.group_id != null
        ? selectionManager.selectedModule().group_id == orderItem.group_id
        : false;

    return (
      <>
        <div
          className={`d-flex border-bottom ${
            isGroupSelected
              ? "bg-fafafa"
              : isLineItemSelected
              ? "bg-cyan"
              : isSiblingOfSelectedLineItem
              ? "bg-fafafa"
              : ""
          } ${orderItem.group_id == null ? "border-top" : ""}`}
          style={{
            alignItems: "stretch",
          }}
          onContextMenu={(e) => {
            if (!selectionManager.isSelected(orderItem)) {
              selectionManager.select(orderItem);
              tableManager.clear();
            }
            e.preventDefault();
            const target = tableManager.isCurrentlyFocused() ? "cell" : "row";
            handleContextMenu(e, target, orderItem);
          }}
        >
          <div
            className="d-flex justify-content-center align-items-center border-end"
            onClick={() => {
              if (selectionManager.isSelected(orderItem)) {
                selectionManager.clear();
                tableManager.clear();
              } else {
                selectionManager.select(orderItem);
                tableManager.clear();
              }

              return true;
            }}
            style={{
              width: isMobileOnly ? "10%" : "35px",
              cursor: orderItem.is_packed ? "grab" : "pointer",
              backgroundColor: isLineItemSelected
                ? "#0d6efd"
                : blurLabel === orderItem.group_id ||
                  blurDirectModuleLabel.includes(orderItem.id)
                ? "#DDD"
                : "transparent",
              color: isLineItemSelected ? "white" : "",
            }}
            {...dragHandleProps}
          >
            <div className="d-flex align-items-center gap-1">
              <span>{orderItem.label}</span>

              {orderItem.module_errors &&
                Object.keys(orderItem.module_errors).length > 0 && (
                  <>
                    <i
                      className="fa-solid fa-circle-exclamation"
                      id={`module-error-icon-${orderItem.id}`}
                      style={{
                        color: "red",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    />
                    <UncontrolledTooltip
                      placement="left"
                      target={`module-error-icon-${orderItem.id}`}
                    >
                      {Object.entries(orderItem.module_errors)
                        .map(([field, messages]) => ` ${messages.join(", ")}`)
                        .join("\n")}
                    </UncontrolledTooltip>
                  </>
                )}
            </div>
          </div>
          <NameCell
            type="module"
            rowId={orderItem.id}
            column="name"
            name={orderItem.name}
            isFiller={orderItem.is_filler}
            tempId={orderItem.temp_id}
            sku={orderItem.sku}
            value={
              pasteOverrides[`${orderItem.id}-module-name`] ??
              orderItemNames[orderItem.id] ??
              orderItem.name ??
              ""
            }
            onChange={(e) => {
              setOrderItemNames((prev) => ({
                ...prev,
                [orderItem.id]: e.target.value,
              }));
              clearPasteOverride(orderItem.id, "module", "name");
            }}
            onFocus={() => {
              if (tableManager.isCurrentlyFocused()) {
                tableManager.set(orderItem.id, "module", "name", "active");
              }
            }}
            onBlur={() => {
              handleUpdateOrderItemData(orderItem.id);
              clearPasteOverride(orderItem.id, "module", "name");
            }}
            disabled={!access.customize_section || orderItem.is_filler}
            invalid={isNameNotValid(orderItemNames[orderItem.id])}
            tableManager={tableManager}
            errorMessage={tableManager.getError(orderItem.id, "module", "name")}
            sectionId={orderItem.group_id}
            pasteOverrides={pasteOverrides[`${orderItem.id}-module-name`]}
            handleTabNavigation={handleTabNavigation}
            onContextMenu={(e) => {
              handleContextMenu(e, "cell", orderItem, {
                id: orderItem.id,
                type: "module",
                column: "name",
              });
            }}
          />
          {((!showSpec && isMobileOnly) || !isMobileOnly) &&
            ["height", "width", "depth"].map((dimension) => {
              const rawValue =
                pasteOverrides[`${orderItem.id}-module-${dimension}`] ??
                moduleDimensions[dimension][orderItem.id];
              const isOverriden = orderItem.dimensions_overriden?.[dimension];
              const placeholder =
                rawValue === "" ? "" : orderItem.dimensions[dimension];
              const inputId = `module_${dimension}_${orderItem.id}`;
              const fixedDimension =
                orderItem.dimensions_range &&
                orderItem.dimensions_range[`min_${dimension}`] ==
                  orderItem.dimensions_range[`max_${dimension}`];
              const hasError = (dimension) =>
                moduleErrorFields.includes(dimension);

              return (
                <>
                  <DimensionCell
                    key={`${orderItem.id}-${dimension}`}
                    type="module"
                    rowId={orderItem.id}
                    dimension={dimension}
                    tempId={orderItem.temp_id}
                    rawValue={rawValue}
                    placeholder={placeholder}
                    disabled={
                      !access.customize_section ||
                      orderItem.is_filler ||
                      fixedDimension
                    }
                    hasError={hasError(dimension)}
                    invalid={
                      isDimensionNotValid(dimension, rawValue) ||
                      (!orderItem.group_id && rawValue === "")
                    }
                    onFocus={() => {
                      if (
                        tableManager.isFocused(
                          "module",
                          orderItem.is,
                          dimension
                        )
                      ) {
                        tableManager.set(
                          orderItem.id,
                          "module",
                          dimension,
                          "active"
                        );
                      }
                      handleDimensionChange(
                        dimension,
                        orderItem.id,
                        orderItem.dimensions[dimension],
                        "module"
                      );
                    }}
                    onChange={(ev) => {
                      handleDimensionChange(
                        dimension,
                        orderItem.id,
                        ev.target.value,
                        "module"
                      );
                      clearPasteOverride(orderItem.id, "module", dimension);
                    }}
                    onBlur={() => {
                      if (rawValue === "") {
                        tableManager.setEditingCell(
                          orderItem.id,
                          "module",
                          dimension
                        );
                      }
                      updateModuleDimensions({
                        orderItem,
                        dimension: {
                          identifier: dimension,
                          value: rawValue,
                        },
                      });
                      clearPasteOverride(orderItem.id, "module", dimension);
                    }}
                    isFiller={orderItem.is_filler}
                    isOverriden={isOverriden}
                    errorMessage={tableManager.getError(
                      orderItem.id,
                      "module",
                      dimension
                    )}
                    sectionId={orderItem.group_id}
                    showClearOverrideTooltip={
                      orderItem.is_packed && isOverriden
                    }
                    blurred={tableManager.shouldBlurCell(
                      orderItem.id,
                      "module",
                      dimension,
                      orderItem.group_id,
                      isOverriden
                    )}
                    tableManager={tableManager}
                    inputId={inputId}
                    pasteOverrides={
                      pasteOverrides[`${orderItem.id}-module-${dimension}`]
                    }
                    handleTabNavigation={handleTabNavigation}
                    onContextMenu={(e) => {
                      handleContextMenu(e, "cell", orderItem, {
                        id: orderItem.id,
                        type: "module",
                        column: dimension,
                      });
                    }}
                  />
                  {!orderItem.is_filler && fixedDimension && (
                    <UncontrolledTooltip target={inputId} placement="top">{`${
                      dimension[0].toUpperCase() + dimension.slice(1)
                    } not editable for this module.`}</UncontrolledTooltip>
                  )}
                </>
              );
            })}
          {((!showSpec && isMobileOnly) || !isMobileOnly) && (
            <ColorCell
              type="module"
              rowId={orderItem.id}
              tempId={orderItem.temp_id}
              sectionId={orderItem.group_id}
              isFillerRow={orderItem.is_filler}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "color"
              )}
              tableManager={tableManager}
              propertyList={orderItem.property_list}
              colorIdentifiers={moduleColorIdentifiers}
              isActive={tableManager.isActive("module", orderItem.id, "color")}
              dialogProps={{
                orderItem,
                access,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
                isAdmin,
              }}
              pasteOverrides={pasteOverrides[`${orderItem.id}-module-color`]}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "color",
                });
              }}
              setCurrentTab={setCurrentTab}
            />
          )}
          {!isMobileOnly && (
            <FillerCell
              type="module"
              rowId={orderItem.id}
              sectionId={orderItem.group_id}
              tempId={orderItem.temp_id}
              isFiller={orderItem.is_filler}
              propertyList={orderItem.property_list}
              tableManager={tableManager}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "filler"
              )}
              dialogProps={{
                orderItem,
                tableManager,
                updateModuleProperties,
                mutateCurrentRoom,
              }}
              pasteOverrides={pasteOverrides[`${orderItem.id}-module-filler`]}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "filler",
                });
              }}
            />
          )}
          {showSpec && (
            <PropertyCell
              type="module"
              rowId={orderItem.id}
              sectionId={orderItem.group_id}
              isFiller={orderItem.is_filler}
              tempId={orderItem.temp_id}
              propertyList={orderItem.property_list}
              errorMessage={tableManager.getError(
                orderItem.id,
                "module",
                "property"
              )}
              tableManager={tableManager}
              colorIdentifiers={moduleColorIdentifiers}
              dialogProps={{
                access,
                isAdmin,
                tableManager,
                orderItem,
                moduleColorIdentifiers,
                updateModuleProperties,
                toggleClearOverrideModal,
                setClearOverrideFunc,
                clearModuleOverrides,
                mutateCurrentRoom,
              }}
              pasteOverrides={pasteOverrides[`${orderItem.id}-module-property`]}
              onContextMenu={(e) => {
                handleContextMenu(e, "cell", orderItem, {
                  id: orderItem.id,
                  type: "module",
                  column: "property",
                });
              }}
            />
          )}

          <PriceCell
            type="module"
            rowId={orderItem.id}
            tempId={orderItem.temp_id}
            price={orderItem.price}
            sectionId={orderItem.group_id}
            isFiller={orderItem.is_filler}
            errorMessage={tableManager.getError(
              orderItem.id,
              "module",
              "price"
            )}
            tableManager={tableManager}
            dialogProps={{
              orderItem,
              tableManager,
            }}
            price_per_sqft={orderItem.price_per_sqft}
          />
        </div>
        {contextMenu.visible && contextMenu.item?.id === orderItem.id && (
          <ContextMenu
            x={contextMenu.x}
            y={contextMenu.y}
            onClose={handleCloseContextMenu}
            onCopy={handleContextMenuCopy}
            onPaste={handleContextMenuPaste}
            onDuplicate={handleDuplicate}
            onDelete={() => {
              setShowItemsDeleteConfirmation(true);
            }}
            disablePaste={!canPaste(contextMenu.target, orderItem)}
            id={orderItem.id}
            target={contextMenu.target}
            item={contextMenu.item}
            cellData={contextMenu.cellData}
            isFillerProduct={orderItem.is_filler}
          />
        )}
      </>
    );
  };

  const blurOverlayStyle = {
    position: "absolute",
    left: 0,
    top: 0,
    width: "60%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    pointerEvents: "auto",
    zIndex: 999,
  };

  const groupIdForModule = (moduleId) => {
    const group = currentRoom.groups.find((group) =>
      group.modules.some((module) => module.id === moduleId)
    );
    return group ? group.id : null;
  };

  const clearSectionDimensionsForGroup = (groupId) => {
    let tempSection = sectionDimensions;
    delete tempSection.depth[groupId];
    delete tempSection.height[groupId];
    delete tempSection.width[groupId];
    setSectionDimensions(tempSection);
  };

  const clearModuleDimensionsForModule = (moduleId) => {
    let tempModule = moduleDimensions;
    delete tempModule.depth[moduleId];
    delete tempModule.height[moduleId];
    delete tempModule.width[moduleId];
    setModuleDimensions(tempModule);
  };

  const tableManager = {
    highlight: (id, type, column) => {
      setHighlightedCell(null);

      requestAnimationFrame(() => {
        setHighlightedCell({ id, type, column });
      });
    },
    set: (id, type, column, status) => {
      setCurrentCell({
        id,
        type,
        column,
        status,
      });

      if (type === "section") {
        const section = selectionManager.findGroup(id);

        if (section) {
          selectionManager.select(section);
        }

        setActiveSectionId(id);
      } else if (type === "module") {
        const module = selectionManager.findModule(id);

        if (module) {
          selectionManager.select(module);
        }
      }
    },
    setStatus: (status) => {
      setCurrentCell({ ...currentCell, status: status });
    },
    setErrorMessage: (errorMessage, rowId, rowType, column) => {
      if (rowType === "section") {
        const group = currentRoom.groups.find((g) => g.id === rowId);
        if (group) {
          group.errorMessage = group.errorMessage || {};
          group.errorMessage[column] = errorMessage;
        }
      } else if (rowType === "module") {
        for (const group of currentRoom.groups) {
          const module = group.modules.find((m) => m.id === rowId);
          if (module) {
            module.errorMessage = module.errorMessage || {};
            module.errorMessage[column] = errorMessage;
            break;
          }
        }
      }
      mutateCurrentRoom && mutateCurrentRoom();
    },
    getError: (rowId, rowType, column) => {
      if (rowType === "section") {
        const group = currentRoom.groups.find((g) => g.id === rowId);
        if (group) {
          return group.errorMessage ? group.errorMessage[column] : null;
        }
      } else if (rowType === "module") {
        for (const group of currentRoom.groups) {
          const module = group.modules.find((m) => m.id === rowId);
          if (module) {
            return module.errorMessage ? module.errorMessage[column] : null;
          }
        }
      }
      return null;
    },
    clearError: (rowType, rowId, column) => {
      if (rowType === "section") {
        const group = currentRoom.groups.find((g) => g.id === rowId);
        if (group && group.errorMessage) {
          delete group.errorMessage[column];
        }
      } else if (rowType === "module") {
        for (const group of currentRoom.groups) {
          const module = group.modules.find((m) => m.id === rowId);
          if (module && module.errorMessage) {
            delete module.errorMessage[column];
            break;
          }
        }
      }
      mutateCurrentRoom && mutateCurrentRoom();
    },
    reloadItem: (rowType, rowId, column) => {
      if (rowType === "section") {
        loadGroup({ projectId, roomId: currentRoom.id, groupId: rowId })
          .then((group) => {
            replaceGroup(group);
            tableManager.clearError(rowType, rowId, column);
            clearSectionDimensionsForGroup(group.id);
          })
          .catch((error) => {
            console.error("Failed to load group", error);
          });
      } else if (rowType === "module") {
        loadModule({
          projectId,
          roomId: currentRoom.id,
          groupId: groupIdForModule(rowId),
          moduleId: rowId,
        })
          .then((module) => {
            replaceModule(module);
            tableManager.clearError(rowType, rowId, column);
            clearModuleDimensionsForModule(module.id);
          })
          .catch((error) => {
            console.error("Failed to load module", error);
          });
      }
    },
    isActive: (rowType, rowId, column) => {
      return (
        currentCell &&
        currentCell.type === rowType &&
        currentCell.id === rowId &&
        currentCell.column === column &&
        currentCell.status === "active"
      );
    },
    isFocused: (rowType, rowId, column) => {
      return (
        currentCell &&
        currentCell.type === rowType &&
        currentCell.id === rowId &&
        currentCell.column === column &&
        currentCell.status === "focus"
      );
    },
    isHighlighted: (rowType, rowId, column) => {
      return (
        highlightedCell &&
        highlightedCell.type === rowType &&
        highlightedCell.id === rowId &&
        highlightedCell.column === column
      );
    },
    isCurrentlyActive: () => {
      return currentCell && currentCell.status === "active";
    },
    isCurrentlyFocused: () => {
      return currentCell && currentCell.status === "focus";
    },
    getStatus: (rowType, rowId, column) => {
      if (
        currentCell &&
        currentCell.type === rowType &&
        currentCell.id === rowId &&
        currentCell.column === column
      ) {
        return currentCell.status;
      } else {
        return "idle";
      }
    },
    isCleared: () => {
      return currentCell === null;
    },
    clear: () => {
      setCurrentCell(null);
    },
    setEditingCell: (rowId, rowType, column) => {
      setEditingCell({ rowId, rowType, column });
    },

    clearEditingCell: () => {
      setEditingCell(null);
    },

    isEditingCell: (rowId, rowType, column) => {
      return (
        editingCell &&
        editingCell.rowId === rowId &&
        editingCell.rowType === rowType &&
        editingCell.column === column
      );
    },
    shouldBlurCell: (
      rowId,
      rowType,
      dimension,
      groupId = null,
      isOverriden = false
    ) => {
      const isEditing = tableManager.isEditingCell(rowId, rowType, dimension);

      if (rowType === "section") {
        return isEditing;
      }

      if (rowType === "module") {
        return (
          isEditing ||
          ((dimension === "width" ||
            tableManager.isEditingCell(groupId, "section", dimension)) &&
            canBlur(groupId, dimension) &&
            !isOverriden)
        );
      }

      return false;
    },
    setCopiedCell: (rowId, rowType, column) => {
      setCopiedCell({ rowId, rowType, column });
    },
    clearCopiedCell: () => {
      setCopiedCell(null);
    },
    isCopiedCell: (rowId, rowType, column) => {
      return (
        copiedCell &&
        copiedCell.rowId === rowId &&
        copiedCell.rowType === rowType &&
        copiedCell.column === column
      );
    },
  };
  useEffect(() => {
    const target = tableManager.isCurrentlyFocused() ? "cell" : "row";
    if (target == "cell") {
      if (tableManager.isCurrentlyFocused().type == "module") {
        orderItem = selectionManager.findModule(
          tableManager.isCurrentlyFocused().id
        );
        handleContextMenu(e, target, orderItem);
      } else if (tableManager.isCurrentlyFocused().type == "section") {
        section = selectionManager.findGroup(
          tableManager.isCurrentlyFocused().id
        );
        handleContextMenu(e, target, section);
      } else if (target == "row") {
        handleContextMenu(e, row, currentSelection);
      }
    }
  }, [tableManager.isCurrentlyFocused(), currentSelection]);
  // Returns the unique property values in the given group.
  const uniqueValues = (group) => {
    const set = new Set();

    group.property_list.forEach((property) => {
      if (
        colorIdentifiers.includes(property.identifier) ||
        !property.overriden
      ) {
        return;
      }

      const selectedOption = property.options.find(
        (option) => option.selected
      )?.name;

      if (!set.has(selectedOption)) {
        set.add(selectedOption);
      }
    });

    return Array.from(set);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id === over.id) return;

    let sortPosition = 1;
    const group = selectionManager.findGroup(
      selectionManager.findModule(active.id).group_id
    );
    const to = over.data.current.sortable.index + 1;

    setBlurLabel(group.id);

    group.modules
      .filter((m) => !m.is_filler)
      .sort((a, b) => a.sort_position - b.sort_position)
      .forEach((m) => {
        if (m.id == active.id) {
          m.sort_position = to;
          return;
        }

        m.sort_position = to > sortPosition ? sortPosition : sortPosition + 1;
        sortPosition++;
      });

    mutateCurrentRoom();

    sortSectionItems({
      projectId,
      groupId: group.id,
      payload: {
        order_item_id: active.id,
        to: over.data.current.sortable.index + 1,
      },
    }).then((section) => {
      replaceGroup(section);
      mutateCurrentRoom();
      setBlurLabel("");
    });
  };
  const handleDirectModuleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id === over.id) return;

    const module = selectionManager.findModule(active.id);
    const modules = currentRoom.modules.filter((m) => !m.is_filler);

    const fromIndex = modules.findIndex((m) => m.id === active.id);
    const toIndex = over.data.current.sortable.index;

    const reordered = [...modules];
    const [moved] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, moved);

    reordered.forEach((m, index) => {
      m.room_sort_order = index + 1;
    });
    const moduleIds = currentRoom.modules.map((module) => module.id);
    setBlurDirectModuleLabel(moduleIds);

    mutateCurrentRoom();

    sortDirectItems({
      projectId,
      roomId: currentRoom.id,
      payload: {
        order_item_id: active.id,
        to: toIndex + 1,
      },
    })
      .then((response) => {
        return loadRoom(response.id);
      })
      .then(() => {
        setBlurDirectModuleLabel([]);
      });
  };

  return (
    <div>
      {notificationMessage.text && (
        <Notification
          color={notificationMessage.type}
          isOpen={isNotificationVisible}
          toggle={onDismissNotification}
        >
          {notificationMessage.text}
        </Notification>
      )}
      {isMobileOnly && <MobileBanner />}
      {currentRoom && projectSummary && (
        <div style={{ position: "relative" }}>
          <FullViewContainer
            className={`new-project-summary ${isLoading ? "blurred" : ""}`}
            style={{ position: "relative" }}
          >
            {editGroup && (
              <CrudModal
                isOpen={editGroup}
                toggle={toggleEditGroup}
                crudAction={(projectId, groupId, payload) =>
                  updateGroup({
                    projectId,
                    groupId,
                    roomId: currentRoom.id,
                    payload,
                  })
                }
                id={projectId}
                name={currentGroup.name}
                groupId={currentGroup.id}
                text="Edit Group"
              />
            )}
            <>
              <SectionTableHeader showSpec={showSpec} />
              <Accordion className="border-bottom">
                {currentRoom.groups.map((group, index) => (
                  <div>
                    <Accordion
                      open={activeSectionId}
                      toggle={() => {}} // No-op.
                      key={group.id}
                    >
                      <AccordionItem className="border-0">
                        <AccordionHeaderContainer className="m-0 p-0">
                          <AccordionHeader
                            targetId={group.id}
                            onContextMenu={(e) => {
                              e.preventDefault();
                              selectionManager.select(group);
                              tableManager.clear();
                              const target = tableManager.isCurrentlyFocused()
                                ? "cell"
                                : "row";
                              handleContextMenu(e, target, group);
                            }}
                          >
                            <div
                              className={`d-flex w-100 border-top ${
                                selectionManager.isSelected(group)
                                  ? "bg-cyan-blue"
                                  : "bg-EEEEEE"
                              }`}
                              // onClick={() => {
                              //   if (selectionManager.isSelected(group)) {
                              //     setActiveSectionId(null);
                              //     selectionManager.clear();
                              //     tableManager.clear();
                              //   } else {
                              //     setActiveSectionId(group.id);
                              //     selectionManager.select(group);
                              //   }

                              //   return true;
                              // }}
                            >
                              <div
                                className="d-flex justify-content-center align-items-center border-end flex-grow-0 flex-shrink-0"
                                onClick={() => {
                                  if (selectionManager.isSelected(group)) {
                                    setActiveSectionId(null);
                                    selectionManager.clear();
                                    tableManager.clear();
                                  } else {
                                    setActiveSectionId(group.id);
                                    selectionManager.select(group);
                                  }

                                  return true;
                                }}
                                style={{
                                  width: isMobileOnly ? "10%" : "35px",
                                  backgroundColor: selectionManager.isSelected(
                                    group
                                  )
                                    ? "#0d6efd"
                                    : "",
                                  color: selectionManager.isSelected(group)
                                    ? "white"
                                    : "",
                                }}
                              >
                                {selectionManager.isSelected(group) ? (
                                  <i className="fa-solid fa-chevron-down" />
                                ) : (
                                  <i className="fa-solid fa-chevron-right" />
                                )}
                              </div>
                              {group.category === "Section" ? (
                                <>
                                  <NameCell
                                    type="section"
                                    rowId={group.id}
                                    column="name"
                                    name={group.name}
                                    tempId={group.temp_id}
                                    value={
                                      pasteOverrides[
                                        `${group.id}-section-name`
                                      ] ??
                                      sectionNames[group.id] ??
                                      group.name ??
                                      ""
                                    }
                                    onChange={(e) => {
                                      setSectionNames((prev) => ({
                                        ...prev,
                                        [group.id]: e.target.value,
                                      }));
                                      clearPasteOverride(
                                        group.id,
                                        "section",
                                        "name"
                                      );
                                    }}
                                    onFocus={() => {
                                      if (tableManager.isCurrentlyFocused()) {
                                        tableManager.set(
                                          group.id,
                                          "section",
                                          "name",
                                          "active"
                                        );
                                      }
                                    }}
                                    onBlur={() => {
                                      handleUpdateSectionName(group.id);
                                      clearPasteOverride(
                                        group.id,
                                        "section",
                                        "name"
                                      );
                                    }}
                                    disabled={
                                      !access.customize_section || group.temp_id
                                    }
                                    invalid={isNameNotValid(
                                      sectionNames[group.id]
                                    )}
                                    tableManager={tableManager}
                                    errorMessage={tableManager.getError(
                                      group.id,
                                      "section",
                                      "name"
                                    )}
                                    copyPasteTooltip={copyPasteTooltip}
                                    pasteOverrides={
                                      pasteOverrides[`${group.id}-section-name`]
                                    }
                                    handleTabNavigation={handleTabNavigation}
                                    onContextMenu={(e) => {
                                      handleContextMenu(e, "cell", group, {
                                        id: group.id,
                                        type: "section",
                                        column: "name",
                                      });
                                    }}
                                  />
                                  {((!showSpec && isMobileOnly) ||
                                    !isMobileOnly) &&
                                    ["height", "width", "depth"].map(
                                      (dimension) => {
                                        const isWidth = dimension === "width";
                                        const inputId = `section_${dimension}_${group.id}`;
                                        const rawValue =
                                          pasteOverrides[
                                            `${group.id}-section-${dimension}`
                                          ] ??
                                          sectionDimensions?.[dimension]?.[
                                            group.id
                                          ] ??
                                          group?.dimensions?.[dimension] ??
                                          "";

                                        return (
                                          <React.Fragment
                                            key={`${group.id}-${dimension}`}
                                          >
                                            <DimensionCell
                                              type="section"
                                              rowId={group.id}
                                              sectionId={group.id}
                                              dimension={dimension}
                                              tempId={group.temp_id}
                                              rawValue={rawValue}
                                              placeholder={rawValue}
                                              isOverriden={false}
                                              isFiller={false}
                                              disabled={
                                                !access.customize_section ||
                                                group.temp_id
                                              }
                                              onFocus={() => {
                                                if (
                                                  tableManager.isFocused(
                                                    "section",
                                                    group.id,
                                                    dimension
                                                  )
                                                ) {
                                                  tableManager.set(
                                                    group.id,
                                                    "section",
                                                    dimension,
                                                    "active"
                                                  );
                                                }
                                              }}
                                              onChange={(ev) => {
                                                tableManager.setEditingCell(
                                                  group.id,
                                                  "section",
                                                  dimension
                                                );
                                                handleDimensionChange(
                                                  dimension,
                                                  group.id,
                                                  ev.target.value,
                                                  "section"
                                                );
                                                clearPasteOverride(
                                                  group.id,
                                                  "section",
                                                  dimension
                                                );
                                              }}
                                              onBlur={() => {
                                                updateSectionDimensions({
                                                  group,
                                                  dimension,
                                                  value: rawValue,
                                                });
                                                clearPasteOverride(
                                                  group.id,
                                                  "section",
                                                  dimension
                                                );
                                              }}
                                              errorMessage={tableManager.getError(
                                                group.id,
                                                "section",
                                                dimension
                                              )}
                                              blurred={false}
                                              showClearOverrideTooltip={false}
                                              tableManager={tableManager}
                                              inputId={inputId}
                                              invalid={
                                                isDimensionNotValid(
                                                  dimension,
                                                  rawValue
                                                ) || rawValue === ""
                                              }
                                              inputStyle={{
                                                color:
                                                  isWidth &&
                                                  group.remaining_width > 3
                                                    ? "#FF0000"
                                                    : undefined,
                                                cursor:
                                                  isWidth &&
                                                  group.remaining_width > 3 &&
                                                  !tableManager.isActive(
                                                    "section",
                                                    group.id,
                                                    dimension
                                                  )
                                                    ? "help"
                                                    : undefined,
                                              }}
                                              pasteOverrides={
                                                pasteOverrides[
                                                  `${group.id}-section-${dimension}`
                                                ]
                                              }
                                              handleTabNavigation={
                                                handleTabNavigation
                                              }
                                              onContextMenu={(e) => {
                                                handleContextMenu(
                                                  e,
                                                  "cell",
                                                  group,
                                                  {
                                                    id: group.id,
                                                    type: "section",
                                                    column: dimension,
                                                  }
                                                );
                                              }}
                                            />
                                            {isWidth && (
                                              <UncontrolledTooltip
                                                target={inputId}
                                                placement="top"
                                              >
                                                {group.remaining_width > 3
                                                  ? `${group.remaining_width}mm space available in this section`
                                                  : "Section width fully packed by modules"}
                                              </UncontrolledTooltip>
                                            )}
                                          </React.Fragment>
                                        );
                                      }
                                    )}
                                  {((!showSpec && isMobileOnly) ||
                                    !isMobileOnly) && (
                                    <ColorCell
                                      type="section"
                                      rowId={group.id}
                                      tempId={group.temp_id}
                                      isFillerRow={false}
                                      sectionId={null}
                                      errorMessage={tableManager.getError(
                                        group.id,
                                        "section",
                                        "color"
                                      )}
                                      tableManager={tableManager}
                                      propertyList={group.property_list}
                                      colorIdentifiers={colorIdentifiers}
                                      isActive={tableManager.isActive(
                                        "section",
                                        group.id,
                                        "color"
                                      )}
                                      dialogProps={{
                                        group,
                                        updateSectionProperties,
                                        mutateCurrentRoom,
                                        isAdmin,
                                      }}
                                      pasteOverrides={
                                        pasteOverrides[
                                          `${group.id}-section-color`
                                        ]
                                      }
                                      onContextMenu={(e) => {
                                        handleContextMenu(e, "cell", group, {
                                          id: group.id,
                                          type: "section",
                                          column: "color",
                                        });
                                      }}
                                      setCurrentTab={setCurrentTab}
                                    />
                                  )}
                                  {!isMobileOnly && (
                                    <FillerCell
                                      type="section"
                                      rowId={group.id}
                                      sectionId={group.id}
                                      tempId={group.temp_id}
                                      isFiller={false}
                                      sides={group.sides}
                                      tableManager={tableManager}
                                      selectionManager={selectionManager}
                                      errorMessage={tableManager.getError(
                                        group.id,
                                        "section",
                                        "filler"
                                      )}
                                      dialogProps={{
                                        group,
                                        tableManager,
                                        updateSectionFillers,
                                        mutateCurrentRoom,
                                        access,
                                        isAdmin,
                                      }}
                                      pasteOverrides={
                                        pasteOverrides[
                                          `${group.id}-section-filler`
                                        ]
                                      }
                                      onContextMenu={(e) => {
                                        handleContextMenu(e, "cell", group, {
                                          id: group.id,
                                          type: "section",
                                          column: "filler",
                                        });
                                      }}
                                    />
                                  )}
                                  {showSpec && (
                                    <PropertyCell
                                      type="section"
                                      rowId={group.id}
                                      sectionId={group.id}
                                      isFiller={false}
                                      tempId={group.temp_id}
                                      propertyList={group.property_list}
                                      errorMessage={tableManager.getError(
                                        group.id,
                                        "section",
                                        "property"
                                      )}
                                      tableManager={tableManager}
                                      colorIdentifiers={colorIdentifiers}
                                      uniqueValues={uniqueValues(group)}
                                      dialogProps={{
                                        group,
                                        access,
                                        isAdmin,
                                        tableManager,
                                        colorIdentifiers,
                                        updateProperties:
                                          updateSectionProperties,
                                        mutateCurrentRoom,
                                      }}
                                      pasteOverrides={
                                        pasteOverrides[
                                          `${group.id}-section-property`
                                        ]
                                      }
                                      onContextMenu={(e) => {
                                        handleContextMenu(e, "cell", group, {
                                          id: group.id,
                                          type: "section",
                                          column: "property",
                                        });
                                      }}
                                    />
                                  )}
                                </>
                              ) : (
                                <Cell
                                  groupId={group.id}
                                  type="section"
                                  column="name"
                                  status="focus"
                                  className="flex-grow-0 flex-shrink-0"
                                  customStyles={{
                                    width: isMobileOnly ? "130px" : "150px",
                                  }}
                                  tableManager={tableManager}
                                  errorMessage={tableManager.getError(
                                    group.id,
                                    "section",
                                    "name"
                                  )}
                                >
                                  <p className="fw-bold mb-0">{group.name}</p>
                                </Cell>
                              )}
                              {
                                <PriceCell
                                  type="section"
                                  rowId={group.id}
                                  tempId={group.temp_id}
                                  price={group.price}
                                  sectionId={group.id}
                                  errorMessage={tableManager.getError(
                                    group.id,
                                    "section",
                                    "price"
                                  )}
                                  tableManager={tableManager}
                                  price_per_sqft={group.price_per_sqft}
                                />
                              }
                              {false && access.group && (
                                <UncontrolledDropdown>
                                  <DropdownToggle className="border-0 p-1 text-dark pe-2 ps-2">
                                    <i className="fa-ellipsis-vertical fa-solid"></i>
                                  </DropdownToggle>
                                  <DropdownMenu className="p-0">
                                    <DropdownItem
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setCurrentGroup({
                                          id: group.id,
                                          name: group.name,
                                        });
                                        toggleEditGroup();
                                      }}
                                    >
                                      <Icon
                                        className="fa-pencil fa-solid me-2"
                                        size="12px"
                                      />
                                      Edit Group Name
                                    </DropdownItem>
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              )}
                            </div>
                          </AccordionHeader>
                          {contextMenu.visible &&
                            contextMenu.item?.id === group.id && (
                              <ContextMenu
                                x={contextMenu.x}
                                y={contextMenu.y}
                                onClose={handleCloseContextMenu}
                                onCopy={handleContextMenuCopy}
                                onPaste={handleContextMenuPaste}
                                onDuplicate={handleDuplicate}
                                onDelete={() => {
                                  setShowItemsDeleteConfirmation(true);
                                }}
                                disablePaste={
                                  !canPaste(contextMenu.target, group)
                                }
                                id={`section-${group.id}`}
                                target={contextMenu.target}
                                item={contextMenu.item}
                                cellData={contextMenu.cellData}
                              />
                            )}
                        </AccordionHeaderContainer>

                        {!group.temp_id &&
                          (selectionManager.selectedModule()?.group_id ==
                            group.id ||
                            selectionManager.isSelected(group)) && (
                            <AccordionBody accordionId={group.id}>
                              {group.modules.length === 0 && (
                                <div className="border-bottom p-4 text-secondary text-center bg-light-grey">
                                  No modules added to this section
                                </div>
                              )}
                              <div>
                                <DndContext
                                  sensors={sensors}
                                  collisionDetection={closestCenter}
                                  onDragEnd={handleDragEnd}
                                  modifiers={[
                                    restrictToVerticalAxis,
                                    restrictToParentElement,
                                  ]}
                                >
                                  <SortableContext
                                    items={group.modules.map((m) => m.id)}
                                    strategy={verticalListSortingStrategy}
                                  >
                                    {group.modules
                                      .filter((m) => !m.is_filler)
                                      .sort(
                                        (a, b) =>
                                          a.sort_position - b.sort_position
                                      )
                                      .map((orderItem) => (
                                        <SortableLineItem
                                          key={orderItem.id}
                                          orderItem={orderItem}
                                          LineItem={LineItem}
                                        />
                                      ))}
                                  </SortableContext>
                                </DndContext>
                              </div>
                              {group.modules
                                .filter((m) => m.is_filler)
                                .sort((a, b) => a.label - b.label)
                                .map((orderItem) => LineItem(orderItem))}
                              {group.category == "Section" &&
                                access.customize_section &&
                                !isMobileOnly && (
                                  <div className="d-flex position-relative">
                                    <Cell
                                      rowType="module"
                                      rowId="new"
                                      column="add_module"
                                      status="focus"
                                      className="ps-4 flex-grow-0 flex-shrink-0"
                                      customStyles={{ width: "185px" }}
                                      tableManager={tableManager}
                                      noBorder={true}
                                      disableAddModuleCell={
                                        disableAddModuleCell
                                      }
                                      errorMessage={tableManager.getError(
                                        "new",
                                        "module",
                                        "add_module"
                                      )}
                                    >
                                      <div className="link pointer py-2 ps-4">
                                        <Icon
                                          className="fa-solid fa-plus me-2"
                                          size="12px"
                                        />
                                        Add modules
                                      </div>
                                    </Cell>
                                    {tableManager.isActive(
                                      "module",
                                      "new",
                                      "add_module"
                                    ) && (
                                      <AddModuleDialog
                                        group={group}
                                        close={tableManager.clear}
                                        setAddedProductLoading={
                                          setAddedProductLoading
                                        }
                                        replaceGroup={replaceGroup}
                                        refreshProjectSummary={
                                          refreshProjectSummary
                                        }
                                        currentRoom={currentRoom}
                                        addedProductsWidth={addedProductsWidth}
                                        setAddedProductsWidth={
                                          setAddedProductsWidth
                                        }
                                        setDisableAddModuleCell={
                                          setDisableAddModuleCell
                                        }
                                        tableManager={tableManager}
                                        setRoom={setRoom}
                                        blurredItems={blurredItems}
                                        setBlurredItems={setBlurredItems}
                                      />
                                    )}
                                  </div>
                                )}
                            </AccordionBody>
                          )}
                      </AccordionItem>
                    </Accordion>
                  </div>
                ))}
                <div>
                  <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={handleDirectModuleDragEnd}
                    modifiers={[
                      restrictToVerticalAxis,
                      restrictToParentElement,
                    ]}
                  >
                    <SortableContext
                      items={currentRoom.modules.map((m) => m.id)}
                      strategy={verticalListSortingStrategy}
                    >
                      {currentRoom.modules
                        .sort((a, b) => a.room_sort_order - b.room_sort_order)
                        .map((orderItem) => (
                          <SortableLineItem
                            key={orderItem.id}
                            orderItem={orderItem}
                            LineItem={LineItem}
                          />
                        ))}
                    </SortableContext>
                  </DndContext>
                </div>
              </Accordion>

              <div
                onContextMenu={(e) => {
                  e.preventDefault();
                  tableManager.clear();
                  handleContextMenu(e, "row", null, null, true);
                }}
                style={{ height: "200px" }}
                className="pt-4"
              >
                <div className="d-flex justify-content-center">
                  {!isMobileOnly && (
                    <Button
                      onClick={toggleAddSectionModal}
                      disabled={!access.customize_section}
                      className="bg-white text-primary border-primary rounded-1 btn btn-primary"
                    >
                      Add Section
                    </Button>
                  )}
                  <Button
                    onClick={setShowAddDirectModules}
                    disabled={!access.customize_section}
                    className="ms-2 bg-white text-primary border-primary rounded-1 btn btn-primary"
                  >
                    Add Modules
                  </Button>
                </div>
                {contextMenu.visible && contextMenu.forDirectModules && (
                  <ContextMenu
                    x={contextMenu.x}
                    y={contextMenu.y}
                    onClose={handleCloseContextMenu}
                    onCopy={handleContextMenuCopy}
                    onPaste={() =>
                      handleContextMenuPaste(contextMenu.forDirectModules)
                    }
                    onDuplicate={handleDuplicate}
                    onDelete={() => {
                      setShowItemsDeleteConfirmation(true);
                    }}
                    target={contextMenu.target}
                    item={contextMenu.item}
                    cellData={contextMenu.cellData}
                    forDirectModules={contextMenu.forDirectModules}
                  />
                )}
              </div>

              {isRightPanelVisible && !isMobileOnly && (
                <div style={blurOverlayStyle} />
              )}

              {!isMobileOnly && (
                <RightPanel
                  isVisible={isRightPanelVisible}
                  onClose={() => setIsRightPanelVisible(false)}
                  selectionManager={selectionManager}
                  access={access}
                  finalisedContexts={finalisedContexts}
                  isorderfinalised={isorderfinalised}
                  currentSelection={currentSelection}
                  currentRoom={currentRoom}
                  projectId={projectId}
                  loadRoom={loadRoom}
                  refreshProjectSummary={refreshProjectSummary}
                />
              )}
            </>
          </FullViewContainer>
        </div>
      )}

      <ConfirmationModal
        isOpen={openClearOverrideModal}
        toggle={toggleClearOverrideModal}
        onConfirm={clearOverrideFunc}
        message="Are you sure you want to remove the property?"
        headingText="Remove Property"
      />
      <ConfirmationModal
        isOpen={showItemsDeleteConfirmation}
        toggle={toggleShowItemsDeleteConfirmation}
        onConfirm={() => deleteSelectedItems(selectionManager.selections())}
        message={`Are you sure you want to delete ${
          selectionManager.selections().length
        } item${selectionManager.selections().length > 1 ? "s" : ""}`}
        headingText="Delete Items"
      />
      {showAddSection && (
        <AddSectionModal
          shouldShow={showAddSection}
          close={() => setShowAddSection(false)}
          toggle={toggleAddSectionModal}
          projectId={projectId}
          currentRoom={currentRoom}
          refreshProjectSummary={refreshProjectSummary}
          setNotification={setNotification}
          setIsNotificationVisible={setIsNotificationVisible}
          mutateCurrentRoom={mutateCurrentRoom}
        />
      )}

      {showAddDirectModules && (
        <AddDirectModuleDialog
          setAddedProductLoading={setAddedProductLoading}
          refreshProjectSummary={refreshProjectSummary}
          currentRoom={currentRoom}
          setShowAddDirectModules={setShowAddDirectModules}
          projectId={projectId}
          mutateCurrentRoom={mutateCurrentRoom}
          replaceModule={replaceModule}
        />
      )}
    </div>
  );
};

const SortableLineItem = ({ orderItem, LineItem }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: orderItem.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    background: isDragging ? "#ccc" : "transparent",
    userSelect: "none",
  };

  return (
    <div ref={setNodeRef} style={style}>
      {LineItem(orderItem, { ...attributes, ...listeners })}
    </div>
  );
};

export default SectionAccordion;
